export default "__VITE_ASSET__QFQjELN2__"